import { makeStyles, createStyles } from '@material-ui/core';

import { SIDEBAR_WIDTH } from 'features/app/components/AppSidebar';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      padding: '0',
      minHeight: '100vh',
      margin: '0',
    },
    right: {
      width: '100%',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },

    rightShift: {
      width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
      marginLeft: ({ direction }: LayoutDirection) => direction === "ltr" ? SIDEBAR_WIDTH: 0,
      marginRight: ({ direction }: LayoutDirection) => direction === "rtl" ? SIDEBAR_WIDTH: 0,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  })
);
